import { Component } from '@angular/core';

@Component({
    selector: 't-and-c-modal',
    template: require('./t.and.c.modal.component.html')
})
export class TermsAndConditionsComponent {
    //TODO: This will need to load the terms and conditions from the database eventually
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/terms.and.conditions.modal/t.and.c.modal.component.ts